{
  "schemaVersion": 1,
  "key": "redeemer",
  "name": "Redeemer Christian",
  "version": "1.0.0",
  "author": "classy core",
  "backgrounds": {
    "home": "backgrounds/home.png"
  },
  "mascot": {
    "home": "mascot/eagle.png"
  },
  "tokens": {
    "accent": "#35537B"
  }
}
